import React from 'react'

const ContextData = React.createContext()

export default ContextData